export default __webpack_public_path__ + "static/media/scrum-lll.cf813169.png";